export const campaigns = () => {
    const $ = jQuery;

    const cookieData = getCookie('ans_utms');

    const utms = cookieData !== undefined ? JSON.parse( decodeURIComponent( cookieData ) ) : {};

    $.ajax({
        url: wpApiSettings.root + 'ans/v1/campaigns',
        method: 'GET',
        data: utms,
        success: (response) => {
            if (response.tel_no) {

                $('#tel-no span').text(response.tel_no);
                $('#tel-no').attr('href', `tel:${response.tel_no.replace(/\s/g, '')}`);
                $('#search-tel-no').attr('href', `tel:${response.tel_no.replace(/\s/g, '')}`);
                $('#nav-login-link').after(`<a class="tel-button" href="tel:${response.tel_no.replace(/\s/g, '')}">Call us</a>`);
            }
        }
    });
};

